// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__tfeG2","requiredAsterisk":"Info_requiredAsterisk__2dEAL"};